import { MockMethod } from 'vite-plugin-mock';

export default [
    {
        url: '/mock/join/recruitment/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: {
                    records: [
                        {
                            id: '1',
                            jobName: 'Unity 开发工程师',
                            workLocation: '广州',
                            recruitmentNum: 5,
                            createTime: '2021-12-3',
                            updateTime: '2021-12-3'
                        },
                        {
                            id: '2',
                            jobName: '算法工程师',
                            workLocation: '广州',
                            recruitmentNum: 2,
                            createTime: '2021-12-3',
                            updateTime: '2021-12-3'
                        },
                        {
                            id: '3',
                            jobName: 'Web 开发工程师',
                            workLocation: '广州',
                            recruitmentNum: 2,
                            createTime: '2021-12-3',
                            updateTime: '2021-12-4'
                        }
                    ],
                    total: 1
                },
                message: 'success'
            };
        }
    },
    {
        url: '/mock/join/recruitment/info',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: {
                    jobName: 'Web开发工程师',
                    workLocation: '广州',
                    workAddress: '广州-黄浦区-香雪八路98号F栋20层2001-1房',
                    workExperience: '1年以上',
                    requirements: '本科及以上',
                    treatment: '年终奖 绩效奖 五险一金',
                    jobDesc: `<strong>岗位职责：</strong><br />
1、参与或负责公司产品线前端项目的研发和维护工作。<br />
2、根据技术规范、产品设计和功能需求，能独立高质量完成前端编码工作。<br />
3、根据产品业务能封装通用组件、在理解产品业务的基础上，结合前端技术能优化 Web 交互方式，提升产品质量。<br />
<br />
<strong>任职要求：</strong><br />
1、熟练运用 JavaScript、TypeScript、HTML5、CSS3，掌握ES5+标准和常用特性，有面向对象OOP编码实践优先。<br />
2、熟练掌握 Vue、React 等前端框架中的一种或多种，ElementUI、Ant Design等UI框架，有 Vue3 开发实践经验优先。<br />
3、熟悉至少会一种以上 CSS 预处理语言，如 Less、Sass 等。<br />
3、熟练前端开发流程，掌握组件模块化、工程化，Webpack/Vite 等打包构建工具。<br />
4、熟悉移动端 Web 应用开发、常用适配解决方案，了解 uniapp 等多端开发框架，有小程序开发经验优先。<br />
5、对编码规范、代码质量、性能优化有一定理解和应用实践，熟练使用 GIT 版本管理工具。<br />
6、有较强的学习能力、良好的团队沟通和协助能力、工作主动积极、热爱技术并善于解决问题。<br />`,
                    recruitmentNum: 2,
                    createTime: '2021-12-3',
                    updateTime: '2021-12-4'
                },
                message: 'success'
            };
        }
    },
    {
        url: '/mock/join/office/image/list',
        method: 'post',
        response: (option:any) =>
        {
            return {
                code: 0,
                data: [
                    {
                        jobName: '办公区1',
                        desc: '',
                        url: 'https://oss.zeewain.com/WEBSITE_RESOURCE/f1e0f0a9b11c4e9f8e689fd60186ec77/%E5%8A%9E%E5%85%AC%E7%8E%AF%E5%A2%831.jpg'
                    },
                    {
                        jobName: '办公区2',
                        desc: '',
                        url: 'https://oss.zeewain.com/WEBSITE_RESOURCE/84293afee9be4bdb8c76af1f6194a1c9/%E5%8A%9E%E5%85%AC%E7%8E%AF%E5%A2%832.jpg'
                    },
                    {
                        jobName: '办公区3',
                        desc: '',
                        url: 'https://oss.zeewain.com/WEBSITE_RESOURCE/32e94d7e4c514c60bab9e95a08aab0aa/%E5%8A%9E%E5%85%AC%E7%8E%AF%E5%A2%833.jpg'
                    }
                ],
                message: 'success'
            };
        }
    }
] as MockMethod[];
